/**
 * Shared helper-feed constants.
 *
 * The "You can help" tab is selected by `?tab=help` on the Notifications screen.
 * Hoisting the param + the full return path here keeps the value in ONE place so
 * the card's `returnTo`, the primer's `returnTo`, and the Notifications tab gate
 * can never drift out of sync (a renamed param would otherwise silently break
 * the back-button landing).
 */

/** The `?tab=` value that selects the "You can help" tab on `/notifications`. */
export const HELPER_FEED_TAB_PARAM = 'help';

/**
 * Where the helper feed lives. Opening a card (or the primer CTA) threads this
 * as `returnTo` so the back button lands the user back on the "You can help" tab.
 */
export const HELPER_FEED_RETURN_TO = `/notifications?tab=${HELPER_FEED_TAB_PARAM}`;
